import { useCallback } from "react";
import { ANALYTICS_EVENTS, type AnalyticsEventName } from "./events";
import { trackAnalyticsEvent } from "./amplitude";
import { useWebViewDetection } from "~@/hooks/useWebViewDetection";

type AnalyticsProperties = Record<string, unknown>;

export const useAnalytics = () => {
  const { isWebView } = useWebViewDetection();

  const track = useCallback(
    (eventName: AnalyticsEventName | string, properties?: AnalyticsProperties) => {
      if (isWebView) {
        return;
      }

      trackAnalyticsEvent(eventName, properties);
    },
    [isWebView]
  );

  return {
    trackEvent: track,
    events: ANALYTICS_EVENTS,
  };
};

export type UseAnalyticsReturn = ReturnType<typeof useAnalytics>;


